import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Music as MusicIcon } from 'lucide-react';
import { musicData } from '../data/musicData';
import MusicCard from '../components/MusicCard';
import '../styles/Music.css';

const Music: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Music by Pedro Sugasti - Electronic Music & Sound Design</title>
        <meta name="description" content="Explore Pedro Sugasti's musical journey - original electronic compositions, remixes, and sound design experiments. Where code meets creativity." />
        
        {/* Open Graph tags */}
        <meta property="og:title" content="Music by Pedro Sugasti - Electronic Music & Sound Design" />
        <meta property="og:description" content="Original electronic compositions and sound design experiments by Pedro Sugasti. Exploring the intersection of technology and sound." />
        <meta property="og:image" content="https://pedrosugasti.com/images/music-preview.jpg" />
        <meta property="og:url" content="https://pedrosugasti.com/music" />
        <meta property="og:type" content="website" />
        
        {/* Twitter Card tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Music by Pedro Sugasti" />
        <meta name="twitter:description" content="Electronic music compositions and sound design experiments." />
        <meta name="twitter:image" content="https://pedrosugasti.com/images/music-preview.jpg" />
        
        <link rel="canonical" href="https://pedrosugasti.com/music" />
      </Helmet>
      
      <div className="music">
      <section className="music-hero">
        <div className="hero-content">
          <MusicIcon size={24} className="music-hero-icon" />
          <div className="music-hero-text">
            <h1>Music</h1>
            <p className="lead">Where code meets creativity - My musical journey</p>
          </div>
        </div>
      </section>

      <section className="music-content">
        <div className="music-intro">
          <h2>The Sound of Code</h2>
          <p>
            Music has always been a parallel passion alongside programming. I explore electronic music production,
            experimenting with synthesizers, digital audio workstations, and the intersection of technology and sound.
          </p>
          <p>
            Here you'll find my original compositions, remixes, and experiments in sound design. Each piece
            represents a journey through different genres and production techniques.
          </p>
        </div>

        <div className="music-grid">
          {musicData.map(track => (
            <MusicCard key={track.id} track={track} />
          ))}
        </div>

        <div className="music-platforms">
          <h2>Listen on Your Favorite Platform</h2>
          <div className="platform-links">
            <a href="https://spotify.com" target="_blank" rel="noopener noreferrer" className="platform-link">Spotify</a>
            <a href="https://soundcloud.com" target="_blank" rel="noopener noreferrer" className="platform-link">SoundCloud</a>
            <a href="https://music.apple.com" target="_blank" rel="noopener noreferrer" className="platform-link">Apple Music</a>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="platform-link">YouTube</a>
          </div>
        </div>
      </section>
      </div>
    </>
  );
};

export default Music;